import { Component, ChangeDetectionStrategy, ElementRef, Renderer2, Input } from '@angular/core';
import { CardBackgroundComponent } from '../../card-background.component';
import { PlainJaneBusinessCardStackBackgroundViewModel } from './plain-jane-business-card-stack-background-view-model';
import type { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-plain-jane-business-card-stack-background',
  templateUrl: './plain-jane-business-card-stack-background.component.html',
  styleUrls: ['./plain-jane-business-card-stack-background.component.scss'],
  providers: [PlainJaneBusinessCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PlainJaneBusinessCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public viewModel: PlainJaneBusinessCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
